import React, { useMemo, useState } from 'react';
// Styled
import { Body, ErrorBody, ModalBody, ModalFooter, ModalTitle, ModalWrapper, WrapperBox } from './orderDetails.style';
// Components
import { Button, CurrencyInput, Loading } from '../../common';
import { Modal, RadioButton, SelectInput } from 'vqp-common';

import { OrderDetailsBox } from './box/orderDetailsBox';
// Services
import useFetch from '../../../utils/useFetch';
import { fetchOrderDetail, postRefund } from '../../../redux/actions/orders';
import { OrderDetailsHeader } from './header/orderDetailsHeader';
import { OrderDetailsCollapseOrder } from './collapse-info/orderDetailsCollapseOrder';
import { OrderDetailsCollapseUser } from './collapse-user/orderDetailsCollapseUser';
import formatCpf from '../../../utils/formatCpf';
import { toBRL } from '../../../utils/formatCurrency';
import { Order } from './order/order';
//Material
import { Box, Snackbar, SnackbarContent } from '@material-ui/core';
import { ErrorOutline as ErrorOutlineIcon } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
//Assets
import Pix from '../../../assets/icons/card/pix.png';
import OrderDetailsRefundCard from './refund-card/refundCard';
import { CustomLabel, RadioGroup, SelectWrapper } from '../../../pages/Cupons/Create/style';

const motivationOptions = [
  {
    value: 1,
    name: 'Pedido extraviado'
  },
  {
    value: 2,
    name: 'Pedido entregue com falta de produtos'
  },
  {
    value: 3,
    name: 'Pedido duplicado'
  },
  {
    value: 4,
    name: 'Problema na Integração com o PDV'
  },
  {
    value: 5,
    name: 'Problemas Operacionais Estabelecimento'
  },
  {
    value: 6,
    name: 'Instabilidade App'
  }];

export const OrderDetailModal = ({ orderId, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    message: '',
    background: '#434040'
  });
  const [isRefundPending, setIsRefundPending] = useState(false);
  const orderDetailResponse = useFetch(fetchOrderDetail, orderId);
  const [orderDetail, setOrderDetail] = useState(null);

  const [selectedMotivation, setSelectedMotivation] = useState(null);
  const [openRefundModal, setOpenRefundModal] = useState(false);

  const [isRefundTotal, setIsRefundTotal] = useState(true);
  const [refundAmount, setRefundAmount] = useState(0);
  const selectedMotivationIndex = useMemo(
    () => motivationOptions.findIndex((option) => option.value === selectedMotivation),
    [selectedMotivation]
  );

  const getOrderTotalForRefund = (detail) => {
    if (!detail) return 0;
    const total = Number(detail.total);
    if (total > 0) return total;
    return Number(detail.subTotal ?? 0);
  };

  useMemo(() => {
    if (orderDetailResponse.response) {
      const response = orderDetailResponse.response;
      setOrderDetail(response);
      setRefundAmount(getOrderTotalForRefund(response));
    }
  }, [orderDetailResponse.response]);


  const orderTotalForRefund = orderDetail ? getOrderTotalForRefund(orderDetail) : 0;
  const refundGreaterThenTotal = useMemo(() => {
    if (orderDetail && orderTotalForRefund > 0)
      return refundAmount > orderTotalForRefund;
    return false;
  }, [refundAmount, orderTotalForRefund, orderDetail]);


  const getOtherInfosBox = () => {
    let box = [];

    if (orderDetail.cpfNote)
      box.unshift({
        title: 'CPF na nota',
        label: formatCpf(orderDetail.cpfNote)
      });

    return box;
  };

  const getPaymentInfosBox = () => {
    let box = [
      {
        title: 'Forma de pagamento',
        label: `${orderDetail.payment} ${orderDetail.cardCompany ? ` - ` + orderDetail.cardCompany.label : ''
          }`,
        src:
          orderDetail.payment === 'Pix'
            ? Pix
            : orderDetail.cardCompany
              ? orderDetail.cardCompany.src
              : null
      }
    ];

    if (orderDetail.thing)
      box.unshift({
        title: 'Troco',
        label: toBRL(orderDetail.thing)
      });

    return box;
  };

  const handleStartRefund = () => {
    if (isRefundTotal && orderDetail) {
      setRefundAmount(getOrderTotalForRefund(orderDetail));
    }
    setOpenRefundModal(true);
  };

  const handleCancelRefund = () => {
    setOpenRefundModal(false);
  };

  const handleConfirmRefund = async () => {
    if (isRefundPending) {
      return;
    }

    setIsRefundPending(true);

    const { cardId } = orderDetail;
    const motivation = selectedMotivation; // options já têm value 1-6

    try {
      const result = await dispatch(postRefund({ cardId, total: refundAmount, motivation }));

      if (result.success) {
        setOrderDetail({ ...orderDetail, paymentStatus: 'Estornado', refund: { ...orderDetail.refund, status: 'DEFAULT' } });
      }

      const snackbarData = result.success
        ? {
          message: 'A solicitação de estorno foi feita com sucesso!',
          backgroundColor: '#119C4A'
        }
        : {
          message: 'Erro ao estornar pagamento. Tente novamente.',
          backgroundColor: '#CD2A0B'
        };

      setSnackbar({
        ...snackbarData, isOpen: true
      });
    }
    catch {
      setSnackbar({
        ...{
          message: 'Erro ao estornar pagamento. Tente novamente.',
          backgroundColor: '#CD2A0B'
        },
        isOpen: true
      });
    }

    setOpenRefundModal(false);
    setTimeout(() => setIsRefundPending(false), 500);
    setRefundAmount(orderDetail ? getOrderTotalForRefund(orderDetail) : 0);
    setSelectedMotivation(null);
    setIsRefundTotal(true)
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason !== 'clickaway') {
      setSnackbar((state) => ({ ...state, isOpen: false }));
    }
  };

  const handleChangeRefundType = (value) => {
    const isTotal = value === true || value === 'true';
    setIsRefundTotal(isTotal);
    if (isTotal && orderDetail) {
      setRefundAmount(getOrderTotalForRefund(orderDetail));
    }
  }

  const handleChangeRefundAmount = (value) => {
    const numericValue = parseFloat(value.replace('R$ ', '').replace(',', '.'));
    if (!isNaN(numericValue)) {
      setRefundAmount(Number(numericValue.toFixed(2)));
    } else {
      setRefundAmount(0);
    }
  }

  const handleSelectMotivation = (selectedIndex) => {
    const option = motivationOptions[selectedIndex];
    setSelectedMotivation(option ? option.value : null);
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        boxWidth="832px"
      >
        {orderDetailResponse.loading ? (
          <WrapperBox>
            <OrderDetailsHeader />
            <Box
              width="100%"
              height="calc(100% - 83px);"
              display="flex"
              alignItems="center"
              justifyContent="center"
              paddingBottom="83px"
            >
              <Loading />
            </Box>
          </WrapperBox>
        ) : orderDetailResponse.error || !orderDetail ? (
          <WrapperBox>
            <OrderDetailsHeader />
            <ErrorBody>
              <Box display="flex">
                <ErrorOutlineIcon
                  style={{ marginBottom: '24px', fontSize: '50px' }}
                  color="error"
                />
                <Box marginLeft="24px">
                  <h4 style={{ marginBottom: 0 }}>
                    {' '}
                    Houve um problema na busca dos dados deste pedido!
                  </h4>
                  <span>
                    Por favor, tente novamente mais tarde. Se o problema persistir entre em contato
                    conosco!{' '}
                  </span>
                </Box>
              </Box>
            </ErrorBody>
          </WrapperBox>
        ) : (
          <WrapperBox>
            <OrderDetailsHeader />
            <Body>
              <OrderDetailsCollapseOrder order={orderDetail} />
              <OrderDetailsCollapseUser order={orderDetail} />
              <Order orderDetail={orderDetail} />
              <Box
                display="flex"
                justifyContent="space-between"
                width="100%"
                style={{ gap: '8px' }}
              >
                {(orderDetail.refund && orderDetail.refund.status) ? (
                  <OrderDetailsRefundCard
                    handleCancelRefund={handleCancelRefund}
                    handleConfirmRefund={handleConfirmRefund}
                    pending={isRefundPending}
                    status={orderDetail.refund.status}
                  />
                ) : (
                  <OrderDetailsBox
                    width={`${getOtherInfosBox().length > 0 ? '50%' : '100%'}`}
                    title="Pagamento"
                    items={getPaymentInfosBox()}
                    status={orderDetail.paymentStatus}
                    isRefundEnabled={!orderDetail.refund.isAvailable}
                    handleRefundClick={handleStartRefund}
                  />
                )}

                {getOtherInfosBox().length > 0 && (
                  <OrderDetailsBox
                    width="50%"
                    title="Outras informações"
                    items={getOtherInfosBox()}
                  />
                )}
              </Box>
            </Body>
          </WrapperBox>
        )}
        <Snackbar
          open={snackbar.isOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <SnackbarContent
            style={{
              backgroundColor: snackbar.backgroundColor
            }}
            message={snackbar.message}
          />
        </Snackbar>

      </Modal>

      <Modal style={{ width: '100px' }} isOpen={openRefundModal} onClose={handleCancelRefund}>
        <ModalWrapper>
          <ModalTitle>Estorno</ModalTitle>
          <ModalBody>
            <SelectWrapper style={{ marginTop: '16px' }}>
              <CustomLabel>Tipo do estorno</CustomLabel>
              <RadioGroup>
                <RadioButton
                  value={true}
                  name="refundType"
                  defaultChecked={isRefundTotal}
                  onChange={handleChangeRefundType}
                >
                  Estorno Total
                </RadioButton>
                <RadioButton
                  value={false}
                  name="refundType"
                  defaultChecked={!isRefundTotal}
                  onChange={handleChangeRefundType}
                >
                  Estorno Parcial
                </RadioButton>
              </RadioGroup>
            </SelectWrapper>
            <SelectWrapper style={{ marginTop: '16px' }}>
              <CustomLabel>Valor do estorno</CustomLabel>
              <CurrencyInput
                value={toBRL(refundAmount)}
                onChange={handleChangeRefundAmount}
                disabled={isRefundPending || isRefundTotal}
                error={refundAmount <= 0 ? "O valor do estorno deve ser maior que zero" : refundGreaterThenTotal ? "O valor do estorno não pode ser maior que o total" : ""}
              />
            </SelectWrapper>

            <SelectWrapper>
              <CustomLabel>Motivo do estorno</CustomLabel>
              <SelectInput
                options={motivationOptions}
                selected={selectedMotivationIndex >= 0 ? selectedMotivationIndex : null}
                onSelect={handleSelectMotivation}
                disabled={isRefundPending}
              />
              <label style={{ color: "red", marginTop: "16px", fontSize: "12px" }}>
                Deseja prosseguir? O estorno é irreversível.
              </label>
            </SelectWrapper>
          </ModalBody>
          <ModalFooter>
            <Button
              className="outlined"
              onClick={handleCancelRefund}
              disabled={isRefundPending}
            >
              Cancelar
            </Button>
            <Button
              className="primary"
              disabled={selectedMotivation === null || isRefundPending || refundAmount <= 0 || refundGreaterThenTotal}
              onClick={handleConfirmRefund}
            >
              Estornar
            </Button>
          </ModalFooter>
        </ModalWrapper>
      </Modal>
    </>
  );
};
